const GENERAL_REGEX = {
	removeComma: {
		pattern: /,/g,
	},
	removeNonDigit: {
		pattern: /\D/g,
	},
	septateThreeCharacter: {
		pattern: /\B(?=(\d{3})+(?!\d))/g,
	},
	onlyPersianAndSpace: {
		pattern: /^[\u0600-\u06FF\s]+$/,
	},
	persianFullName: {
		pattern: /^[\u0600-\u06FF]{2,}(?:\s+[\u0600-\u06FF]{2,})+$/,
	},
};

export default GENERAL_REGEX;
